module.exports = __webpack_public_path__ + "assets/download-google.fd3b8f48.svg";